import { Button, Popover, PopoverContent, PopoverTrigger, Badge } from '@nextui-org/react';
import { Icon } from '@iconify/react';
import { useUserNotifications } from '@/context/user-notifications/hooks';
import { NotificationCardNav } from '@modules/notification/components/notification-card-nav';

export const NotificationNav = () => {
  const { unreadNotifications } = useUserNotifications();
  return (
    <Popover offset={12} placement="bottom-end">
      <PopoverTrigger>
        <Button disableRipple isIconOnly radius="full" variant="light" className="overflow-visible">
          <Badge color="danger" content={unreadNotifications} showOutline={false} size="md">
            <Icon className="text-default-500" icon="solar:bell-linear" width={20} />
          </Badge>
        </Button>
        {/* <Button disableRipple isIconOnly className="overflow-visible" radius="full" variant="light"> */}
        {/*     <Icon className="text-primary-foreground/60" icon="solar:bell-linear" width={22} /> */}
        {/* </Button> */}
      </PopoverTrigger>
      <PopoverContent className="max-w-[90vw] p-0 sm:max-w-[380px]">
        <NotificationCardNav className="w-full shadow-none" />
      </PopoverContent>
    </Popover>
  );
};
